<template>
  <!-- @vue-ignore -->
  <Bar
    ref="refElement"
    :key="key"
    :options="options"
    :data="data"
  />
</template>

<script setup lang="ts">
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
} from 'chart.js';
import useForceRender from '@/Composables/useForceRender';
import { type ChartData } from '@/types';
import GraphColoursData = App.Data.Settings.ReportDesign.GraphColoursData;

const { refElement, key } = useForceRender();

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const props = withDefaults(defineProps<{
  data: ChartData[];
  direction?: 'vertical' | 'horizontal';
  prefix?: string;
  suffix?: string;
  barRounding?: number;
  graphColours: GraphColoursData;
}>(), {
  direction: 'vertical',
  barRounding: 6,
});

const options: any = {
  indexAxis: props.direction === 'vertical' ? 'y' : 'x',
  animation: {
    duration: 0,
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: 'black',
      bodyAlign: 'center',
      displayColors: false,
      padding: 12,
      titleAlign: 'center',
      callbacks: {
        label: ((tooltipItems: any) => `${props.prefix ?? ''}${tooltipItems.formattedValue}`),
      },
    },
  },
  scales: {
    x: {
      display: props.direction === 'vertical',
      grid: {
        display: false,
      },
      position: 'top',
      ticks: {
        callback: (value: number | string) => `${props.prefix ?? ''}${value}${props.suffix ?? ''}`,
        stepSize: 50,
      },
    },
    y: {
      border: {
        display: false,
      },
      display: props.direction !== 'vertical',
      ticks: {
        callback: (value: number | string) => `${props.prefix ?? ''}${value}${props.suffix ?? ''}`,
      },
    },
  },
};

const data = {
  labels: props.data.map((element) => element.label),
  datasets: [
    {
      backgroundColor: [
        props.graphColours.colourOne,
        props.graphColours.colourTwo,
        props.graphColours.colourThree,
        props.graphColours.colourFour,
      ],
      borderRadius: props.barRounding,
      data: props.data.map((element) => Math.round(<number>element.value)),
      hoverBackgroundColor: [
        props.graphColours.colourOne,
        props.graphColours.colourTwo,
        props.graphColours.colourThree,
        props.graphColours.colourFour,
      ],
      categoryPercentage: 0.8,
    },
  ],
};
</script>
